export class ResendToGovTypeModel {
  label: string;
  value: string;
}
